import ACTION_ITEMS from '../actionItems';

export function setConfirm(params) {
  return (dispatch) => {
    dispatch({
      type: ACTION_ITEMS.GLOBAL.CONFIRM.SET,
      payload: params,
    });
  };
}
